import React, { createContext, useContext, useState } from "react";
// 1. Create context
const AccountContext = createContext(null);
// 2. Provider
export const AccountProvider = ({ children }) => {
  const [selectedAccount, setSelectedAccount] = useState("");
  return (
    <AccountContext.Provider
      value={{
        selectedAccount,
        setSelectedAccount,
      }}
    >
      {children}
    </AccountContext.Provider>
  );
};
// 3. Custom hook (recommended)
export const useAccount = () => {
  const context = useContext(AccountContext);
  if (!context) {
    throw new Error("useAccount must be used within an AccountProvider");
  }
  return context;
};
